@if (isOpen) {
<div
  class="ios-install-modal fixed inset-0 z-50 flex items-end bg-black/30 animate-fade-in"
>
  <div
    class="w-full bg-white rounded-t-2xl p-6 animate-slide-up max-h-[80vh] overflow-y-auto"
  >
    <div class="flex justify-between items-center mb-6">
      <h2 class="text-xl font-bold text-surface-900">
        {{ 'shared.pwa.ios-instructions.title' | translate }}
      </h2>
      <button
        (click)="onCloseDialog.emit()"
        class="text-surface-600 hover:text-surface-900 text-2xl"
      >
        ✕
      </button>
    </div>

    <div class="space-y-6">
      <div>
        <div class="flex items-center gap-3 mb-2">
          <div
            class="bg-primary text-white rounded-full w-8 h-8 flex items-center justify-center font-bold flex-shrink-0"
          >
            1
          </div>
          <h3 class="font-semibold text-surface-900">
            {{ 'shared.pwa.ios-instructions.step1-title' | translate }}
          </h3>
        </div>
        <p class="text-surface-600 text-sm ml-11">
          {{ 'shared.pwa.ios-instructions.step1-desc' | translate }}
        </p>
      </div>

      <div>
        <div class="flex items-center gap-3 mb-2">
          <div
            class="bg-primary text-white rounded-full w-8 h-8 flex items-center justify-center font-bold flex-shrink-0"
          >
            2
          </div>
          <h3 class="font-semibold text-surface-900">
            {{ 'shared.pwa.ios-instructions.step2-title' | translate }}
          </h3>
        </div>
        <p class="text-surface-600 text-sm ml-11">
          {{ 'shared.pwa.ios-instructions.step2-desc' | translate }}
        </p>
      </div>

      <div>
        <div class="flex items-center gap-3 mb-2">
          <div
            class="bg-primary text-white rounded-full w-8 h-8 flex items-center justify-center font-bold flex-shrink-0"
          >
            3
          </div>
          <h3 class="font-semibold text-surface-900">
            {{ 'shared.pwa.ios-instructions.step3-title' | translate }}
          </h3>
        </div>
        <p class="text-surface-600 text-sm ml-11">
          {{ 'shared.pwa.ios-instructions.step3-desc' | translate }}
        </p>
      </div>

      <div>
        <div class="flex items-center gap-3 mb-2">
          <div
            class="bg-primary text-white rounded-full w-8 h-8 flex items-center justify-center font-bold flex-shrink-0"
          >
            4
          </div>
          <h3 class="font-semibold text-surface-900">
            {{ 'shared.pwa.ios-instructions.step4-title' | translate }}
          </h3>
        </div>
        <p class="text-surface-600 text-sm ml-11">
          {{ 'shared.pwa.ios-instructions.step4-desc' | translate }}
        </p>
      </div>
    </div>

    <button
      (click)="onCloseDialog.emit()"
      class="w-full mt-8 bg-primary text-white py-3 rounded-lg font-semibold hover:bg-primary-600 transition-colors"
    >
      {{ 'shared.pwa.ios-instructions.done' | translate }}
    </button>
  </div>
</div>
}
